import type { FC } from "react";

import { cn } from "@/lib/utils";

interface SubtitleProps {
  title: string;
  classes?: string;
  id?: string;
}

const Subtitle: FC<SubtitleProps> = ({ title, classes = "mb-5", id }) => {
  return (
    <h3 className={cn("text-xl font-extrabold text-gray-950", classes)} id={id}>
      {title}
    </h3>
  );
};

export default Subtitle;
